/* eslint-disable no-unneeded-ternary */
/* eslint-disable linebreak-style */
/* eslint-disable no-case-declarations */
/* eslint-disable linebreak-style */
/* eslint-disable no-new */
/* eslint-disable linebreak-style */
/* eslint-disable no-cond-assign */
/* eslint-disable array-callback-return */
/* eslint-disable no-restricted-globals */
/* eslint-disable prefer-arrow-callback */
/* eslint-disable prettier/prettier */
/* eslint-disable object-shorthand */
/* eslint-disable func-names */

import Vue from 'vue/dist/vue';
import Vuex from 'vuex/dist/vuex';
import { order } from 'js/modules/vue/modules/order-builder';
import { cart } from 'js/modules/vue/modules/sidecart';

Vue.use(Vuex);

export const store = new Vuex.Store({
    modules: {
        order: order,
        cart: cart,
    },
});



// WEBPACK FOOTER //
// ./app/js/modules/vue/store.js